import React, {useCallback, useMemo} from 'react';
import classNames from 'classnames';

import cx from './barChartItem.module.scss';
import {getCountsByYears, getPercentageByCounts} from '../../assets/years.data';

const BarChartItem = ({isActivated = false, isVisible, years, onClick}) => {
  const handleClick = useCallback(() => onClick(years), [onClick, years]);
  const counts = useMemo(() => getCountsByYears(years), [years]);
  const percentage = useMemo(() => getPercentageByCounts(counts), [counts]);

  return (
    <div className={cx.wrap}>
      <div className={classNames(cx.item, {
        [cx.isActivated]: isActivated,
        [cx.isDisabled]: (!isVisible && !isActivated),
      })}>
        <div className={cx.text}>
          <div className={cx.percentage}>{percentage}<span className={cx.unit}>%</span></div>
        </div>
        <div className={cx.bar} style={{height: `${percentage * 1.5 + 20}px`}}>
          <button className={cx.inner} type="button" onClick={handleClick}>
            <div className={cx.upper}>
              {counts}<span className={cx.units}>회사</span>
            </div>
          </button>
        </div>
        <div className={cx.years}>{years}</div>
      </div>
    </div>
  )
};

export default BarChartItem;
